import React from 'react';

import { TrainingTypeEnum } from '@/constants/trainingTypeOptions';
import { PositionTrainingMatrixFilters } from '@/state/PositionTrainingMatrixFilter.atom';
import { RegulatoryTrainingMatrix } from '@/types/Training';
import { userCanSeeTraining } from '@/utils/handleSavePermissions';

import { Button } from '../../components/atoms/Button';
import { ExtractRegulatoryTrainingMatrixButton } from '../atoms/ExtractRegulatoryTraningMatrixButton';
import { ExtractTrainingAuditButton } from '../atoms/ExtractTrainingAuditButton';

interface RegulatoryTrainingHeaderSectionProps {
	canSave: boolean | undefined;
	isEditMode: boolean;
	trainingsData: RegulatoryTrainingMatrix | undefined;
	filteredData: PositionTrainingMatrixFilters;
	toggleEditMode: () => Promise<void>;
	setIsNewTraininigModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const RegulatoryTrainingHeaderSection = ({
	canSave,
	isEditMode,
	trainingsData,
	filteredData,
	toggleEditMode,
	setIsNewTraininigModalOpen,
}: RegulatoryTrainingHeaderSectionProps) => {
	const canExtract: boolean | undefined = userCanSeeTraining();

	return (
		<div className="absolute -top-10 right-20 flex items-center">
			<Button
				className="mx-5 h-7 rounded-[1rem] text-xs font-medium"
				onClick={() => setIsNewTraininigModalOpen(true)}
				disabled={!canSave}
			>
				Cadastrar Treinamento
			</Button>
			{trainingsData && trainingsData.trainings?.length > 0 && (
				<Button
					className="mx-5 h-7 rounded-[1rem] text-xs font-medium"
					onClick={toggleEditMode}
					disabled={
						!canSave && !trainingsData.trainings.some((it) => it.isResponsible)
					}
				>
					{isEditMode ? 'Salvar' : 'Editar'} Matriz
				</Button>
			)}
			{canExtract && (
				<ExtractRegulatoryTrainingMatrixButton
					filteredData={filteredData}
					disabled={isEditMode}
				/>
			)}
			{canExtract && (
				<ExtractTrainingAuditButton
					filteredData={filteredData}
					trainingType={TrainingTypeEnum.REGULATORY}
				/>
			)}
		</div>
	);
};
